var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['take-note-input', 'input-container', _vm.getFocusClass('takeNote')]},[_c('v-select',{attrs:{"placeholder":"Take Note Of","hide-details":"","items":_vm.options,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', { field: 'takeNote', newValue: $event })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }